
export enum PlanoTipo {
    GRATIS = "Grátis",
    PAGO = "Pago",
}